<template>
  <div class="settings_right">
    <template v-if=" !editItem">
      <workflowList @editMe="editMe" @showMe="showMe" />
    </template>
    <template v-else>
      <div
        class="form_section workflow_edit"
        v-if="checkProperty(workflowDetailsData, '_id')"
      >
      
        <div class="edit_title">
          <a  @click="editItem = false">
            <chevron-left-icon
              size="1.5x"
              class="custom-class"
            ></chevron-left-icon>
          </a>
          <h4>{{ checkProperty(workflowDetailsData, "name") }}</h4>
          
        </div>
      
        <template v-if="isLoaded && activityList.length > 0">
          <div class="form-container" v-if="isLoaded">

<div   v-if="currentStep == 1">
   <div class="title_block">
              <label class="form_label">Workflow Type</label>
              <div class="table_switch">
                

                  <vs-switch
          success
           v-model="workflowTypeswitch"
          name="workflowTypeswitch"
          :disabled="true"
        >
          <template #off>
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </template>
          <template #on>
            <check-icon size="1.5x" class="custom-class"></check-icon>
          </template>
        </vs-switch>


              </div>
            </div>
            <div class="vx-row">
              <div class="custom-radio_wrap wf_radio">
                <ul class="custom-radio ">
                  <li>
                    <vs-radio    name="workflowType" @input="updateWorkflowType" vs-value="Free-Flow" v-model="workflowType" class="w-full"
                      ><span id="Free-Flow">Free-Flow</span></vs-radio> 
                  </li>
                  <li>
                      <vs-radio  :disabled="checkProperty(workflowDetailsData, 'tplTypeId')==5"  name="workflowType"  @input="updateWorkflowType" vs-value="Sequential"   v-model="workflowType" class="w-full"
                      ><span id="Sequential">Sequential</span></vs-radio> 
                  </li>
                </ul>
              </div>
          </div>

            <div class="title_block">
              <label class="form_label">When will the case be assigned for further processing?</label>
              <div class="table_switch">
                

                  <vs-switch
          success
           v-model="workflowTypeswitch"
          name="assignUsersOnswitch"
          :disabled="true"
        >
          <template #off>
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </template>
          <template #on>
            <check-icon size="1.5x" class="custom-class"></check-icon>
          </template>
        </vs-switch>


              </div>
            </div>
            <div class="vx-row">
              <div class="custom-radio_wrap wf_radio">
                <ul class="custom-radio ">
                  <li>
                    <vs-radio    name="assignUsersOn"  vs-value="case-created" v-model="assignUsersOn" class="w-full"
                      >On Case Creation</vs-radio > 
                  </li>
                  <li v-if="[5].indexOf(tplTypeId)<=-1">
                      <vs-radio    name="assignUsersOn"  vs-value="questionnaire-submitted"   v-model="assignUsersOn" class="w-full"
                      >On Case Submission</vs-radio > 
                  </li>
                </ul>
              </div> 
            </div> 
    </div>

            <template v-for="(tr, indextr) in activityList">
              <template v-if="tr.showMe">
                <div :key="indextr">
                  <workflowActivityOption
                    :activityList="activityList"
                    :workflowDetails="workflowDetailsData"
                    :currentStep="currentStep"
                    :userRolesListEditors="userRolesListEditors"
                    :userRolesList="userRolesList"
                    :currentIndex="indextr"
                    :tenantDetails="checkProperty(workflowDetailsData ,'tenantDetails')"
                    :item="tr"
                    @manageRfeCaseAction="manageRfeCaseAction()"
                  />
                </div>
              </template>
            </template>
          </div>
          <div class="form-footer">
            <button
              v-if="currentStep > 1"
              @click="toggleSteps('back')"
              class="cancel"
            >
              Back
            </button>
            <button
              v-if="currentStep < 3"
              @click="toggleSteps('continue')"
              class="save"
            >
              Continue
            </button>
        
            <template v-if="currentStep == 3">
              <!---- v-if="workflowDetailsData && !workflowDetailsData.configCompleted" --->
              <template>
                    <button
             @click="setUpcomplete()"
              class="save"
            >
                <span v-if="isdefaultWorkflowComplted == false">
                  Complete Setup
                  </span>
                  <span v-else>
                      Submit
                  </span>
            </button>

              </template>
              <!---
          <template
            v-if="workflowDetailsData && workflowDetailsData.configCompleted"
          >
            <vs-button
              color="save"

              @click="
                configCompleted = false;
                conformNewworkflowPopup = false;
                updateMe();
              "
              class="md:w-1/7 w full primary-btn"
              type="filled"
              >Update
            </vs-button>
          </template> -->
            </template>
          </div>
        </template>
      </div>
    </template>

    <div
      v-if="checkProperty(workflowDetailsData, '_id')"
      class="workflow_view_wrap"
      :class="{ listopen: showWorkflowview }"
    >
      <div class="workflow_overlay"></div>
      <div class="workflow_view_cnt pt-0 pb-0">
        <div
          class="workflow_view_title view__title"
          :class="{ 'pr-0': type == 'showWorkflowview' }"
        >
        <div class="workflow_title-cnt">
        
          <label>{{ checkProperty(workflowDetailsData, "name") }}

            <span v-if="checkProperty(workflowDetailsData, 'workflowType')">
              {{ workflowDetailsData['workflowType']=='Free-Flow'?' Free Flow ':workflowDetailsData['workflowType'] }}            
            </span>
          </label>
          <label>
          <span v-if="['case-created','questionnaire-submitted'].indexOf(checkProperty(workflowDetailsData, 'assignUsersOn')) >-1">
             Assign {{ workflowDetailsData['assignUsersOn']=='case-created'?' On Case Creation ':'On Case Submission' }}             
            </span>
          </label>
          
        </div>
          <span @click="showWorkflowview = false">
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </span>
        </div>

        <div class="workflow_view_sec" :data="list">
          <!-- <template slot="thead">
                    <vs-th> Activity </vs-th>
                    <vs-th>Editors</vs-th>
                    <vs-th>Watchers </vs-th>
                </template> -->
          <div class="workflow_view_head">
            <ul>
              <li class="activity">Activity</li>
              <li class="editors">Editors</li>
              <li class="watchers">Watchers</li>
            </ul>
          </div>

          <template>
            <div class="workflow_view_body">
              
              
              <template v-for="(tr, indextr) in activityList">

               
                <workflowActivityView
                  :key="indextr"
                  :activityList="activityList"
                  :item="tr"
                  :currentIndex="indextr"
                  :workflowDetailsData="workflowDetailsData"
                />
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <vs-popup
      class="holamundo main-popup"
      title="Complete Setup"
      v-if="activatePopUp"
      :active.sync="activatePopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full mb-3">
            <h5>Are you sure want to continue and complete the setup ?</h5>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="activatePopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="completeSetup()"
          >Yes</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      title="Complete Setup"
      v-if="conformNewworkflowPopup"
      :active.sync="conformNewworkflowPopup"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>{{ msg }}</p>

            <div class="form_group">
              <label class="form_label">Name<em>*</em></label>
              <vs-input :key="'Name'"
                v-model="newName"
                name="Name"
                v-validate="'required'"
                class="w-full"
                data-vv-as="Workflow Name"
              />
              <span class="text-danger text-sm" v-if="errors.has('Name')">{{
                errors.first("Name")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="conformNewworkflowPopup = false"
          >No</vs-button
        >
        <vs-button
          :disabled="newName.trim() == ''"
          color="success"
          class="save"
          type="filled"
          @click="updateMe(true)"
          >Yes</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      title="Delete form and letters"
      :active.sync="approveConformpopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            {{ actionText }}
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="approveConformpopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="deleteformandLetter()"
          >Delete</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo main-popup"
      :title="edit ? 'Edit Workflow' : 'Add Workflow'"
      v-if="addPopup"
      :active.sync="addPopup"
    >
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <label for class="form_label">Workflow Name<em>*</em></label>
                <vs-input :key="'WorkflowTitle'"
                  @click="formerrors.msg = ''"
                  v-model="newform.name"
                  name="Workflow Title"
                  v-validate="'required'"
                  class="w-full"
                  data-vv-as="Workflow Name"
                />
                <span
                  class="text-danger text-sm"
                  v-if="errors.has('Workflow Title')"
                  >{{ errors.first("Workflow Title") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="[1].indexOf(getUserRoleId) > -1">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Customer</label>

                <div class="con-select">
                  <multiselect
                    :limit="limitItems"
                    v-model="selectedTenant"
                    :options="tenantsList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Customer"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>-->
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-if="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer">
          <vs-button
            color="dark"
            @click="
              edit = false;
              createNew(false);
            "
            class="cancel"
            type="filled"
            >Cancel</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            v-if="edit"
            @click="ConfigTemplate()"
            type="filled"
            >Update</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            v-else
            @click="createConfigTemplate()"
            type="filled"
            >Save</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="'Clone Workflow'"
      v-if="clonePopup"
      :active.sync="clonePopup"
    >
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <label class="form_label">Workflow Name<em>*</em></label>
              <vs-input :key="'newform.name'"
                @click="formerrors.msg = ''"
                v-model="newform.name"
                placeholder="Workflow Name"
                name="Workflow Name"
                v-validate="'required'"
                class="w-full"
                data-vv-as="Workflow Name"
              />
              <span
                class="text-danger text-sm"
                v-if="errors.has('Workflow Name')"
                >{{ errors.first("Workflow Name") }}</span
              >
            </div>
          </div>

          <div class="vx-row" v-if="[1].indexOf(getUserRoleId) > -1">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Customer</label>

                <div class="con-select">
                  <multiselect
                    :limit="limitItems"
                    v-model="selectedTenant"
                    :options="tenantsList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Customer"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>-->
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-if="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer">
          <vs-button
            color="dark"
            @click="createNew(false)"
            class="cancel"
            type="filled"
            >Cancel</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            @click="cloneTemplate()"
            type="filled"
            >Clone</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="
        (checkProperty(selectedItem, 'active') ? 'Inactivate ' : ' Activate') +
        ' Workflow'
      "
      v-if="activateItem"
      :active.sync="activateItem"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>
              Are you sure of
              {{ checkProperty(selectedItem, "active") ? "In " : "" }}activating
              this workflow?
            </p>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="activatePopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="activateTemplate()"
          >{{
            checkProperty(selectedItem, "active") ? "Inactivate " : " Activate"
          }}</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="'Workflow Case Configuration'"
      v-if="configPopup"
      :active.sync="configPopup"
    >
      <div class="form-container" @ckick="formerrors.msg = ''">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <label for class="form_label">Case Type</label>
                <multiselect
                  :limit="limitItems"
                  name="Case Configuration"
                  v-model="selectedPetition"
                  :multiple="false"
                  :show-labels="false"
                  :ref="'Case Configuration'"
                  track-by="_id"
                  label="name"
                  data-vv-as="Case Type"
                  placeholder="Select Case Type"
                  :options="tempPetitionTypeList"
                  :searchable="true"
                  :allow-empty="false"
                >
                </multiselect>
              </div>
            </div>
          </div>
        </div>

        <div
          class="text-danger text-sm form_info"
          v-if="formerrors.msg"
          @click="formerrors.msg = ''"
        >
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
            >{{ formerrors.msg }}</vs-alert
          >
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="configPopup = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          :disabled="selectedPetition == null"
          type="filled"
          @click="workFlowconfigAction()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker-inv";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import FileUpload from "vue-upload-component/src";
import * as _ from "lodash";
import { InfoIcon } from "vue-feather-icons";
import { ChevronLeftIcon } from "vue-feather-icons";
import { XIcon } from "vue-feather-icons";
import { CheckIcon } from "vue-feather-icons";
import Paginate from "vuejs-paginate";
import NoDataFound from "@/views/common/noData.vue";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";

import { MoreVerticalIcon } from "vue-feather-icons";
import workflowList from "@/views/workflowList";
import workflowActivityOption from "./workflowActivityOption";
import workflowActivityView from "./workflowActivityView.vue";

export default {
  data: () => ({
    tplTypeId:0,
    type:'',
    LocalActivityList:[],
    limitItems: 1,
    selecteCaseTypes: [],
    activateItem: false,
    showWorkflowview: false,
    msg: "",
    newName: "",
    tenantDetails: null,
    currentStep: 1,
    bal: false,
    usersList: [
      "SUPERVISOR_LIST",
      "PARALEGAL_LIST",
      "DOCUMENTATION_MANAGER_LIST",
      "DOCUMENTATION_EXECUTIVE_LIST",
      "ATTORNEY_LIST",
    ],
    assignMentUsersList: {
      ASSIGN_SUPERVISOR: "SUPERVISOR_LIST",
      ASSIGN_PARALEGAL: "PARALEGAL_LIST",
      ASSIGN_DOCUMENTATION_MANAGER: "DOCUMENTATION_MANAGER_LIST",
      ASSIGN_DOCUMENTATION_EXECUTIVE: "DOCUMENTATION_EXECUTIVE_LIST",
      ASSIGN_ATTORNEY: "ATTORNEY_LIST",
    },
    lcsRequiredIndex: -1,
    IncludeSwitch: true,
    ActionSwitch: false,
    lcaSubmitRequired: false,
    workflowDetails: null,
    workflowDetailsData: null,
    defaultWorkflowConfCompleted: true,
    editItem: false,
    isValied: false,
    activityList: [],
    finalActivity: [],
    userRolesList: [],
    userRolesListEditors: [],
    masterRoleList:[],
    edit: false,
    workflowId: "",
    activatePopUp: false,
    editorsCount: 0,
    watcherCount: 0,
    includeCount: 0,
    actionRequiredCount: 0,
    workFlowName: "",
    workflowType:"Sequential",
    assignUsersOn:"questionnaire-submitted",
    showPetitionAlert: true,
    conformNewworkflowPopup: false,
    setupCompletedPopup: false,
    setupCompletedPopupmessage: "",
    configCompleted: false,
    code: "",
    isLoaded: false,

    //List veriables

    contentLoaded: false,
    tenantsList: [],
    selectedTenant: null,
    filteredTenants: [],
    finalFilteredTenants: [],
    callFromSerch: false,
    selectedPetition: null,
    configPopup: false,
    petitionTypeList: [],
    tempPetitionTypeList: [],
    workFlowConfigDetails: [],
    activatePopUp: false,
    all_status: [
      {
        name: "Active",
        id: true,
      },
      {
        name: "Inactive",
        id: false,
      },
    ],
    all_active_status: [
      {
        name: "Active",
        id: true,
      },
      {
        name: "Inactive",
        id: false,
      },
    ],
    all_config_status: [
      {
        name: "Complete",
        id: true,
      },
      {
        name: "Pending",
        id: false,
      },
    ],
    selected_active_statusids: [],
    final_active_statusids: [],

    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    all_formTypes: [
      {
        name: "Form",
        id: "Form",
      },
      {
        name: "Letter",
        id: "Letter",
      },
    ],

    selectedItem: null,
    selectedStatus: 2,
    actionText: "Do you want to Delete?",
    formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,
    workflowTypeswitch:true,
    newform: {
      name: "",
      fields: [],
      sections: [],
    },
    list: [],
    addPopup: false,
    NewPetition: false,

    searchtxt: "",
    query: [],
    country_code: 231,
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    filter_roleIds: [],
    final_filter_roleIds: [1, 2, 3, 4, 5, 8, 9, 10, 11],

    seleted_states: [],
    final_selected_states: [],
    locations: [],
    // locationIds
    final_selected_config_completed_statusids: [],
    selected_config_completed_statusids: [],

    date_range: [],
    page: 1,
    perpage: 25,
    totalpages: 0,

    sortKeys: {},
    sortKey: {},
    details: null,
    getMasterData: true,
    clonePopup: false,

    editorsCount: 0,
    watcherCount: 0,
    includeCount: 0,
    actionRequiredCount: 0,
  }),
  methods: {

    manageRfeCaseAction(){

      let val = this.checkProperty( this.$store,'state','manageRfeCase' );
      if(['with_in_case','filed_separately'].indexOf( val)>-1 ){
        
      
       let tempActivityList = _.cloneDeep(this.activityList);
     //  this.activityList =[];
       let activityList =[];

        _.map(this.activityList,(item)=>{

            if(['RFE_DOC_SIGNER_LIST','RFE_CASE_APPROVED','RFE_PREPARE_RESPONSE_DOCS','RFE_REVIEW_RESPONSE_DOCS','REF_CASE_APPROVED','RFE_REQUEST_PETITIONER_SIGN','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.checkProperty(item, 'code'))>-1 ){ 
                  if(val=='with_in_case'){
                    item.include = true;
                    item.showMe= true
                    item.actionRequired =true;
                    item.optional =true;
                    if(['RFE_DOC_SIGNER_LIST', 'RFE_PREPARE_RESPONSE_DOCS','RFE_REVIEW_RESPONSE_DOCS','REF_CASE_APPROVED','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.checkProperty(item, 'code'))>-1 ){ 
                      item.optional =false
                    }
                    //this.item.optional =false
                  }else if(val=='filed_separately'){
                    item.include = false;
                    item.showMe= false;
                    item.actionRequired =false;
                    item.editors =[];
                    item.watchers =[];
                  
                  }
            }
           // activityList.push(item);
         })
     //setTimeout(()=>{
   //   this.activityList = _.cloneDeep(activityList);

    //},100);
    

    }
    },
    updateWorkflowType(){ 
      if(this.workflowType){
        this.workflowDetailsData.workflowType =this.workflowType;
      }
    },
    getenants() {
      let matcher = {};
      let query = {};
      query["page"] = 1;
      query["perpage"] = 10000;
      query["getMasterData"] = true;
      query["filters"] = matcher;

      this.$store
        .dispatch("getList", {
          data: query,
          path: "/tenant/list",
        })
        .then((response) => {
          this.tenantsList = response.list;
        });
    },
    showMe(tr) {
      this.showWorkflowview = !this.showWorkflowview;
      this.workflowId = tr["_id"];
      this.getworkflowDetails();
      //this.workflowDetails
    },
    scrollWIndow() {
      setTimeout(() => {
        const $ = JQuery;
        $("html, body").animate(
          {
            scrollTop: ($(".text-danger").length > 0)? $(".text-danger").first().offset().top: 0,
          },
          2000
        );
      }, 500);

      //  const firstField = Object.keys(this.errors.collect())[0];
      // const ele = $('[name=' + firstField + ']').parents('.vx-col');
      //  $('html, body').animate({ scrollTop: ele.offset().top }, 2000);
    },

    toggleSteps(direction = "") {
      if (direction == "back") {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
        const $ = JQuery;
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          500
        );
      }
      if (direction == "continue") {
        //alert(this.validateData())
        if (this.validateData()) {
          if (this.currentStep < 3) {
            this.currentStep++;
          }

          const $ = JQuery;
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            500
          );
        } else {
          this.scrollWIndow();
        }
      }

      this.isLoaded = false;
      this.isLoaded = true;
    },
    setUpcomplete() {
      if (this.validateData()) {
        this.configCompleted = true;
        this.processWorkflowforDB();
        this.updateMe();
      } else {
        this.scrollWIndow();
      }
    },
    processWorkflowforDB() {
     
      this.finalActivity = [];
      let corierTracking = {
        code: "UPDATE_USCIS_RECEIPT_NUMBER",
        name: "Update Recepit Number",
        editors: [
          {
            roleId: 5,
            roleName: "Front Office User",
          },
        ],
        watchers: [],
        include: "Yes",
        actionRequired: "Yes",
      };
      _.forEach(this.activityList, (item, index) => {
        let tempItem = {
          code: item.code,
          name: item.name,
          description: item.description,
          editors: [],
          watchers: [],
          include: "No",
          actionRequired: "No",
          canAssignAllUsers:null,
          confirmRequired:null
        };
        if (
          [
            "CREATE_PETITION",
            "SUBMIT_BY_BENEFICIARY",
            "SUBMIT_TO_LAW_FIRM",
            "LCA_REQUEST"
          ].indexOf(item.code) > -1
        ) {
          if (["CREATE_PETITION"].indexOf(item.code) > -1) {
            tempItem["editors"] = item["editors"] = [ { roleId: 50,roleName: "Petitioner", }, ];
            tempItem["actionRequired"] = item["actionRequired"] = "Yes";
            if(this.getTenantTypeId ==2){
              tempItem["editors"] = item["editors"] = [   { roleId: 3, roleName: "Admin", },  { roleId: 4,  roleName: "Branch Manager", }  ];

            }

          }
          
           if ( ["LCA_REQUEST"].indexOf(item.code) > -1) {
           /*
            if(this.getTenantTypeId !=2){
              tempItem["editors"] = item["editors"] = [
              {
                roleId: 50,
                roleName: "Petitioner",
              },
             ];

            }
            */
            
           
            
            
          }
          
          if (["SUBMIT_BY_BENEFICIARY"].indexOf(item.code) > -1) {
            tempItem["editors"] = item["editors"] = [
              {
                roleId: 51,
                roleName: "Beneficiary",
              },
            ];
            tempItem["actionRequired"] = item["actionRequired"] = "Yes";
          }
          if ( this.getTenantTypeId !=2 && ["SUBMIT_TO_LAW_FIRM"].indexOf(item.code) > -1) {
            tempItem["editors"] = item["editors"] = [
              {
                roleId: 50,
                roleName: "Petitioner",
              },
            ];
            tempItem["actionRequired"] = item["actionRequired"] = "Yes";
          }

          if (item.include) {
            tempItem.include = "Yes";
          }
          if (item["watchers"].length > 0) {
            tempItem["watchers"] = item["watchers"];
          }
        } else {
        }

         var SUPERVISOR_LIST = _.find(this.activityList, {
          code: "SUPERVISOR_LIST",
        });

        var PARALEGAL_LIST = _.find(this.activityList, {
          code: "PARALEGAL_LIST",
        });

        if (
          item["code"] == "ASSIGN_PARALEGAL" &&
          PARALEGAL_LIST.actionRequired
        ) {
          var _findprev = _.find(this.activityList, {
            code: "SUPERVISOR_LIST",
            actionRequired: true,
          });
          if (_findprev) {
            tempItem["editors"] = _findprev["editors"];
          }
          _findprev = _.find(this.activityList, {
            code: "ASSIGN_SUPERVISOR",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
        }

        var ATTORNEY_LIST = _.find(this.activityList, {
          code: "ATTORNEY_LIST",
        });

        if (item["code"] == "ASSIGN_ATTORNEY" && ATTORNEY_LIST.actionRequired) {
          var _findprev = _.find(this.activityList, {
            code: "PARALEGAL_LIST",
            actionRequired: true,
          });

          if (_findprev) {
            tempItem["editors"] = _findprev["editors"];
          }

          _findprev = _.find(this.activityList, {
            code: "SUPERVISOR_LIST",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
          _findprev = _.find(this.activityList, {
            code: "ASSIGN_SUPERVISOR",
            actionRequired: true,
          });

          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
        }

        if (item["code"] == "CASE_APPROVED" && item.actionRequired) {
          var _findprev = _.find(this.activityList, {
            code: "CASE_APPROVED",
            actionRequired: true,
          });
          if (_findprev) {
            tempItem["editors"] = _findprev["editors"];
          }

          _findprev = _.find(this.activityList, {
            code: "PARALEGAL_LIST",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }

          _findprev = _.find(this.activityList, {
            code: "SUPERVISOR_LIST",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
          _findprev = _.find(this.activityList, {
            code: "ASSIGN_SUPERVISOR",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
        }

        var DOCUMENTATION_MANAGER_LIST = _.find(this.activityList, {
          code: "DOCUMENTATION_MANAGER_LIST",
        });

        if (
          item["code"] == "ASSIGN_DOCUMENTATION_MANAGER" &&
          DOCUMENTATION_MANAGER_LIST.actionRequired
        ) {
          var _findprev = _.find(this.activityList, {
            code: "PARALEGAL_LIST",
            actionRequired: true,
          });
          if (_findprev) {
            tempItem["editors"] = _findprev["editors"];
          }
          _findprev = _.find(this.activityList, {
            code: "SUPERVISOR_LIST",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
          _findprev = _.find(this.activityList, {
            code: "ASSIGN_SUPERVISOR",
            actionRequired: true,
          });
          if (_findprev && tempItem["editors"].length == 0) {
            tempItem["editors"] = _findprev["editors"];
          }
        }

        var DOCUMENTATION_EXECUTIVE_LIST = _.find(this.activityList, {
          code: "DOCUMENTATION_EXECUTIVE_LIST",
        });

        if (
          item["code"] == "ASSIGN_DOCUMENTATION_EXECUTIVE" &&
          DOCUMENTATION_EXECUTIVE_LIST.actionRequired
        ) {
          var _findprev = _.find(this.activityList, {
            code: "DOCUMENTATION_MANAGER_LIST",
            actionRequired: true,
          });
          if (_findprev) {
            tempItem["editors"] = _findprev["editors"];
          }
        }

        if (tempItem["editors"].length == 0 && item["editors"].length > 0) {
          tempItem["editors"] = item["editors"];
        }

        if (item["watchers"].length > 0) {
          tempItem["watchers"] = item["watchers"];
        }

        if (item.include) {
          tempItem.include = "Yes";
        }

        if (item.actionRequired) {
          tempItem.actionRequired = "Yes";
        }

        if (
          item["code"] == "ASSIGN_PARALEGAL" &&
          !PARALEGAL_LIST.actionRequired
        ) {
          tempItem["actionRequired"] = "No";
        }

        if (
          item["code"] == "ASSIGN_ATTORNEY" &&
          !ATTORNEY_LIST.actionRequired
        ) {
          tempItem["actionRequired"] = "No";
        }

        if( item["code"] == "ASSIGN_SUPERVISOR" && !SUPERVISOR_LIST.actionRequired){
             tempItem["actionRequired"] = "No";
        }

         var _findlcaRequest = _.find(this.activityList, {
          code: "LCA_REQUEST",
        });
        if (item["code"] == "LCA_SUBMIT" && !_findlcaRequest.actionRequired) {
              tempItem["actionRequired"] = "No";
        }

      

        if(tempItem["actionRequired"] == "No"){
             tempItem.include = "No";
        }

        if(item["canAssignAllUsers"]!=null){
          tempItem.canAssignAllUsers = item["canAssignAllUsers"];

        }

        if(item['code']=== 'COLLECT_ADV_EVIDENCE' ){
          if(item["approvedPwdReqForAdvEvidences"] =="Yes"){
            tempItem.approvedPwdReqForAdvEvidences = "Yes";
            tempItem['approvedPwdReqForAdvEvidencesBol']=true;

          }else{

            tempItem.approvedPwdReqForAdvEvidences = 'No';
            tempItem['approvedPwdReqForAdvEvidencesBol']=false;

          }
        }
          //PREPARE_PERM_APPLICATION

        if(item['code']=== 'PREPARE_PERM_APPLICATION' ){
          if(item["restrictPermDraftByAdvConfig"] =="Yes"){
            tempItem.restrictPermDraftByAdvConfig = "Yes";
            tempItem['restrictPermDraftByAdvConfigBol']=true;

          }else{

            tempItem.restrictPermDraftByAdvConfig = 'No';
            tempItem['restrictPermDraftByAdvConfigBol']=false;

          }
          


        }

        if(item["confirmRequired"]!=null){
          tempItem.confirmRequired = item["confirmRequired"];

        }

        this.finalActivity.push(tempItem);
      });
    },
    completeSetup() {
      if (this.validateData()) {
        this.configCompleted = true;
        this.updateMe();
      } else {
        this.scrollWIndow();
      }
    },
    validateData() {
     
      let returnValue = true;
       let tempActivityList = ["PAYMENT_INTEGRATION", "ASSIGN_PARALEGAL", "ASSIGN_DOCUMENTATION_MANAGER", "ASSIGN_DOCUMENTATION_EXECUTIVE", "ASSIGN_ATTORNEY"]
      // if(this.getTenantTypeId ==2){
      //     tempActivityList = ["PAYMENT_INTEGRATION", "ASSIGN_PARALEGAL", "ASSIGN_DOCUMENTATION_MANAGER", "ASSIGN_DOCUMENTATION_EXECUTIVE", "ASSIGN_ATTORNEY"]
      // }

     let LCA_REQUEST = _.find( this.activityList  , {"code":"LCA_REQUEST"})
      _.forEach(this.activityList, (item, index) => {
        if(this.getTenantTypeId ==1){

          if(['DOC_SIGNER_LIST'].indexOf(item.code) >-1){
            item.actionRequired =false;
            item.editors =[];

          }


        }
        if (item.code != "LCA_SUBMIT" && (item.code !=='FILE_AFTER_INVOICE' && item.code !='FILE_AFTER_INVOICE_PAYMENT') && tempActivityList.indexOf(item.code) < 0 && item.step == this.currentStep && item.actionRequired == true && item.editors.length == 0) {
 
         returnValue = false;
          item.showError = true;
          
        }
        if(item.code == "LCA_SUBMIT" && item.code !=='FILE_AFTER_INVOICE' && item.code !='FILE_AFTER_INVOICE_PAYMENT' && (LCA_REQUEST && LCA_REQUEST['actionRequired'] ==true) && item.editors.length == 0 && item.step == this.currentStep){
            returnValue = false;
            item.showError = true;
           

        }
      });

      return returnValue;
    },
    updateMe(callFromNew = false) {
      this.$vs.loading();
      let finalStatusUpdateActivity = _.find(this.activityList, {"code":'UPDATE_USCIS_RESPONSE'});
       //alert(this.checkProperty(finalStatusUpdateActivity ,'manageRfeCase'))
      if (this.validateData()) {
        //showPetitionAlert

        let postData = {
          name: this.workFlowName,
          workflowType:this.workflowType,
          assignUsersOn:this.assignUsersOn,
          config: this.finalActivity,
          workflowId: this.workflowId,
          configCompleted: true,
          active: true,
        };
      
     
       if(_.has( finalStatusUpdateActivity,'manageRfeCase', ['with_in_case','filed_separately'].indexOf( this.checkProperty(finalStatusUpdateActivity, 'manageRfeCase'))>-1  )){
        postData = Object.assign(postData,{'manageRfeCase':'with_in_case' });
        postData['manageRfeCase'] = this.checkProperty(finalStatusUpdateActivity, 'manageRfeCase')
       }

        if (this.selecteCaseTypes && this.selecteCaseTypes.length > 0) {
          //
        }

        if (callFromNew) {
          postData["name"] = this.newName.trim();
          postData["configCompleted"] = true;
          if (
            this.newName.trim().toLowerCase() ==
            this.workflowDetailsData.name.trim().toLowerCase()
          ) {
            this.showToster({
              message: "Workflow is already exists",
              isError: true,
            });
            return false;
          }
        }

        postData["configCompleted"] = true;
        postData["active"] = true;

        if (this.conformNewworkflowPopup) {
          postData = Object.assign(postData, {
            showPetitionAlert: false,
          });
          this.showPetitionAlert = false;
          this.configCompleted = false;
        } else {
          postData = Object.assign(postData, {
            showPetitionAlert: true,
          });
        }
        this.cod = "";
    
        this.$store
          .dispatch("updateWorkflow", {
            data: postData,
            path: "/workflow/update",
          })
          .then((response) => {
            this.conformNewworkflowPopup = false;
            this.activatePopUp = false;

            if (_.has(response, "code")) {
              this.code == response["code"];
            }

            if (this.showPetitionAlert && this.code == "LINKED_WITH_PETITION") {
              this.conformNewworkflowPopup = true;
              this.showPetitionAlert = false;
            } else {
              if (this.currentStep < 3) {
                this.currentStep++;
              }
            }
            // this.getTenantDetails();

            if (this.isdefaultWorkflowComplted === false) {
              this.$emit("showSetupCompleted", response);
            } else {
              this.showToster({
                message: response.message,
                isError: false,
              });
            }

            this.activatePopUp = false;
            if (!this.editItem) {
              setTimeout(() => {
                this.$emit("activateSettingTab", "questionnarie");
              }, 100);
            }
            if (this.defaultWorkflowConfCompleted && this.editItem) {
              this.editItem = false;
              this.getList();
            }
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            if (_.has(error, "code")) {
              this.code == error["code"];
              if (error["code"] == "LINKED_WITH_PETITION") {
                this.conformNewworkflowPopup = false;
                this.conformNewworkflowPopup = true;
                this.showPetitionAlert = false;
                this.msg = error.message;
                this.newName = "";
              }
            } else {
              this.getTenantDetails();
            }
            this.showToster({
              message: error.message,
              isError: true,
            });
          });
      }
    },
   
    getUserRoles() {
      let matcher = {
        searchString: "",
        statusIds: [],
        createdDateRange: [],
      };

      let query = {};
      query["page"] = 1;
      query["perpage"] = 100000;
      query["matcher"] = matcher;
      query["category"] = "user_roles";
      query["getMasterData"] = true;

      this.userRolesList = [];
      this.userRolesListEditors = [];
      this.isLoaded = false;
      this.$vs.loading();
      this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
          let userRolesList = response.list;
          this.masterRoleList = response.list;

          this.masterRoleList = _.filter(response.list ,(role)=>{
            return   [14,49].indexOf(role.id)<=-1
          })
          if(this.getTenantTypeId ==2){
            this.masterRoleList = _.filter(response.list ,(role)=>{
              return   role.id !=50;
            })
          }
          userRolesList = _.cloneDeep(this.masterRoleList);
         
          // let tempMasterRoleList = [];
          // _.forEach(this.masterRoleList, (item)=>{
          //   item = Object.assign(item, {'uniqueId':item['id']+item['id']});
          //   tempMasterRoleList.push(item);
          // })
          // if(this.checkProperty(this.workflowDetailsData, 'tplTypeId') == 7){
          //   let obj ={"_id":"855824824a4c1dd92070872d","id":51,'uniqueId':5159,"name":"Sponsor","sortName":"Sponsor"}
          //   let findObj = _.find(tempMasterRoleList, {'name':obj['name']});
          //   if(!findObj){
          //     tempMasterRoleList.push(obj)
          //   }
          // }
          // this.masterRoleList = tempMasterRoleList;
          //  console.log(JSON.stringify(this.masterRoleList))
        

          let removeUsers =[1, 2,12, 51]
          if(this.getTenantTypeId ==2){
            removeUsers = [1, 2,50, 51];
           }
          let tempList = [];
          _.forEach(userRolesList, (item) => {
            if (removeUsers.indexOf(item.id) <= -1) {
              tempList.push({
                roleId: item["id"],
                roleName: item["name"],
                uniqueId:item['id']+item['id']
              });
            }
          });
          this.userRolesList = tempList;
                    let tempListeditors = [];
          _.forEach(userRolesList, (item) => {
            if (removeUsers.indexOf(item.id) <= -1) {
              tempListeditors.push({
                roleId: item["id"],
                roleName: item["name"],
                uniqueId:item['id']+item['id']
              });
            }
          });
          this.userRolesListEditors = tempListeditors;
          if([7,8].indexOf(this.checkProperty(this.workflowDetailsData, 'tplTypeId'))>-1){
            let tempuserRolesList = _.filter(this.userRolesList,(item)=>{
              return   item.roleId !=50;
            });
            let obj={
            
              roleId: 51,
              uniqueId:5151,
              roleName: 'Sponsor'
            };
            let findObj = _.find(tempuserRolesList, {'roleName':obj['roleName']});
            if(!findObj){
              tempuserRolesList.push(obj)
            }
            this.userRolesList = tempuserRolesList
          }
          if([7,8].indexOf(this.checkProperty(this.workflowDetailsData, 'tplTypeId'))>-1){
            let tempuserRolesListEditors = _.filter(this.userRolesListEditors,(item)=>{
              return   item.roleId !=50;
            });
            let obj={
            
              roleId: 51,
              uniqueId:5151,
              roleName: 'Sponsor'
            };
            let findObj = _.find(tempuserRolesListEditors, {'roleName':obj['roleName']});
            if(!findObj){
              tempuserRolesListEditors.push(obj)
            }
            this.userRolesListEditors = tempuserRolesListEditors
          }
          

          this.isLoaded = true;
          this.$vs.loading.close();

          /*
                        "roleId": 11,
                        "roleName": "Beneficiary"
                        */
                       this.mapUserRoles();
        })
        .catch((error) => {
          
          this.isLoaded = true;
          this.$vs.loading.close();
        });
    },
    getActivityList() {
      let _self =this;
      //selectedTenant
      this.$store
        .dispatch("getActivityCodes")
        .then((response) => {
         
              let submitTolawFrimEditors =[
                    

                      {
                    "roleId":3,
                    "roleName":"Admin"
                    },

                     {
                        "roleId":4,
                        "roleName":"Branch Manager"
                    },
                    {
                    "roleId":5,
                    "roleName":"Front Office User"
                    },
              ];
              let submitTolawFrimWatchers =[
                    {
                    "roleId":3,
                    "roleName":"Admin",
                    'uniqueId':6
                    },
                     {
                        "roleId":4,
                        "roleName":"Branch Manager",
                        'uniqueId':8
                    }
              ];
            
              _.forEach(response ,(item)=>{
                   if((_self.getTenantTypeId ==2 ) || ([1].indexOf(_self.getUserRoleId)>-1 &&  _self.checkProperty(_self.selectedTenant ,'typeId') ==2   ) ){
                     
                 
                     if (["DOC_SIGNER_LIST"].indexOf(item.code) > -1) {
                        item['editors'] = [{ roleId: 12, roleName: "Authorized Signatory" ,'uniqueId':24}];
                        item['actionRequired'] = "Yes";
                        item["watchers"] = [];
                        item['showMe'] =true;
                     }   


                     if (["CREATE_PETITION"].indexOf(item.code) > -1) {
                          item['editors'] = [{ roleId: 3, roleName: "Admin", 'uniqueId':6 },{ roleId: 4, roleName: "Branch Manager", 'uniqueId':8}];
                          item['watchers']=submitTolawFrimWatchers
                     }
                     
                      if( ['SUBMIT_BY_BENEFICIARY' ,"SUBMIT_TO_LAW_FIRM" ,"LCA_REQUEST"].indexOf(item['code'])>-1){
                        //item.editors = submitTolawFrimEditors;
                         item['watchers']=submitTolawFrimWatchers
                         item.showMe =true;
                        
                      }
                      if(item['code'] =="LCA_REQUEST"){
                       // item.editors = submitTolawFrimEditors;
                         item.showMe =true;
                        
                      }
                      
                   }else{


                      if (["DOC_SIGNER_LIST"].indexOf(item.code) > -1) {
                        item['editors'] = [{ roleId: 12, roleName: "Authorized Signatory",'uniqueId':24 }];
                        item['actionRequired'] = "No";
                        item["watchers"] = [];
                        item['showMe'] =false;
                     } 
                     if(["SUBMIT_TO_LAW_FIRM" ,"DOC_SIGNER_LIST"].indexOf(item['code'])>-1 ){
                       item.showMe =false;
                     }

                   }


              })
          this.LocalActivityList = response;
          this.activityList = response;
          
        })
        .catch((error) => {
         
        });
    },
    getworkflowDetails(callFromEdit = false) {
     
      let postData = {
        workflowId: this.workflowId,
      };
      this.$store.commit('updateManageRfeCase', '')
      this.$store
        .dispatch("commonAction", {
          data: postData,
          path: "/workflow/details",
        })
        .then((response) => {
          //alert(JSON.stringify(response));
          if (response) {
            this.workflowDetailsData = response;

            
            
            this.selectedTenant = this.checkProperty(this.workflowDetailsData ,'tenantDetails');
           

            this.workFlowName = response["name"];
            this.workflowType= response["workflowType"];
            this.workflowDetails = response["config"];
            this.tplTypeId =0;
            if(this.checkProperty(this.workflowDetailsData, 'tplTypeId' )){
              this.tplTypeId =this.workflowDetailsData['tplTypeId'];

            }
            if(callFromEdit){
              this.getUserRoles();
            }
            //if rfe work flow remove DOCUMENTATION_EXECUTIVE_LIST
            
            let tempActivityList = [];

            //LocalActivityList
            _.forEach(response["config"], (dbData, ind) => {
              dbData['order'] = ind;
              dbData['showError'] = false;
              
             

              let localActivity = _.find(this.LocalActivityList, {  code: dbData["code"] });

              //"step":1, showMe:true, optional:true, showError:false
              if(localActivity){
                  if(_.has(localActivity ,'step')){
                    dbData['step'] = localActivity['step']
                  }else{
                    dbData['step'] = 2;

                  }

                  if(_.has(localActivity ,'showMe')){
                    dbData['showMe'] = localActivity['showMe']
                  }else{
                    dbData['showMe'] = true;

                  }

                  if(_.has(localActivity ,'optional')){
                    dbData['optional'] = localActivity['optional']
                  }else{
                    dbData['optional'] = false;

                  }

                  if(dbData['code'] =="ASSIGN_SUPERVISOR" && this.workflowDetailsData.workflowType =='Free-Flow'){

                      if(!_.has(dbData ,'canAssignAllUsers')){
                        dbData['canAssignAllUsersVal'] = true
                        dbData['canAssignAllUsers'] ="Yes";
                      }else{
                        
                        if(dbData['canAssignAllUsers'] =="Yes"){
                          dbData['canAssignAllUsersVal'] = true;
                        }else{
                          dbData['canAssignAllUsersVal'] = false;
                          dbData['canAssignAllUsers'] ="No";
                        }

                      }

                      

                  }
                  


                
                  //

                                

              }else{

                dbData['step'] = 2;
                dbData['showMe'] = true;
                dbData['optional'] = false;
                dbData['showError'] = false;
                

              }
                
                
              if(dbData["include"] =="Yes"){
                dbData["include"] =true;
              }else{
                dbData["include"] =false;
              }
              if(dbData["actionRequired"] =="Yes"){
                dbData["actionRequired"] =true;
              }else{
                dbData["actionRequired"] =false;
              }
                // if( dbData["code"] == 'ASSIGN_SUPERVISOR'){
                //   dbData["include"] = true;
                //   dbData["actionRequired"] = true;

                // }

                if( dbData["code"] == 'INTERNAL_APPROVE_JOB_DESC'){
                  dbData["optional"] = true;
                 }

                 // REF WORK Flow
                 if(this.tplTypeId==5){
                  this.assignUsersOn ='case-created';
                  
                  if( dbData["code"] == 'REQUEST_PETITIONER_SIGN'){
                     dbData["optional"] = true;

                   }

                   if( ['ASSIGN_DOCUMENTATION_MANAGER','DOCUMENTATION_MANAGER_LIST','ASSIGN_DOCUMENTATION_EXECUTIVE',"DOCUMENTATION_EXECUTIVE_LIST"].indexOf(dbData["code"]) >-1){
                      dbData["optional"] = false;
                      
                                           
                   }
                   if( ['ASSIGN_DOCUMENTATION_EXECUTIVE',"DOCUMENTATION_EXECUTIVE_LIST"].indexOf(dbData["code"]) >-1){
                      dbData["optional"] = true;
                      
                                           
                   }

                   

                 }

                 if(this.checkProperty(this.workflowDetailsData, 'workflowType') =='Free-Flow' && ['SUPERVISOR_LIST','ASSIGN_PARALEGAL','PARALEGAL_LIST','ASSIGN_DOCUMENTATION_MANAGER','DOCUMENTATION_MANAGER_LIST','ASSIGN_DOCUMENTATION_EXECUTIVE','DOCUMENTATION_EXECUTIVE_LIST'].indexOf(dbData.code) > -1  && !_.has(dbData, 'confirmRequiredVal')){
                  
                  dbData = Object.assign(dbData, {"confirmRequiredVal":false })
                   }
                
                if([1].indexOf(this.tplTypeId) >-1 && ['UPDATE_USCIS_RESPONSE'].indexOf(dbData.code) >-1 ){
                  
                    if(['with_in_case','filed_separately'].indexOf( this.checkProperty(this.workflowDetailsData, 'manageRfeCase') )>-1 ){

                    
                    dbData['manageRfeCase'] = this.workflowDetailsData['manageRfeCase'];
                    this.$store.commit('updateManageRfeCase',this.workflowDetailsData['manageRfeCase']);


                  }
                  
                } 
                if( [1].indexOf(this.tplTypeId) >-1 && ['RFE_DOC_SIGNER_LIST','RFE_PREPARE_RESPONSE_DOCS','RFE_CASE_APPROVED','RFE_REQUEST_PETITIONER_SIGN','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER', 'RFE_DOC_SIGNER_LIST', 'RFE_UPDATE_USCIS_RESPONSE'].indexOf(dbData.code) >-1  && ['with_in_case','filed_separately'].indexOf( this.checkProperty(this.workflowDetailsData, 'manageRfeCase') )>-1 ){
                  
                  dbData['showError'] = false;
                  dbData['step'] = 3;
                  if(!_.has(dbData, 'optional')){

                    dbData['optional'] = false;
                    if(['RFE_REQUEST_PETITIONER_SIGN','RFE_CASE_APPROVED'].indexOf(dbData.code) >-1 ){
                      dbData['optional'] = true;
                    }
                  }
                 
                }  



                
                tempActivityList.push(dbData);
                

                
               
              
            });
            // console.log(JSON.stringify(dbCodes))
            // let orderMap = {};
            // dbCodes.forEach(item => {
            //     orderMap[item.code] = item.order;
            // });
          
            // Sort dataCodes based on the order from baseCodes
            // dataCodes.sort((a, b) => {
            //     return orderMap[a.code] - orderMap[b.code];
            // });
            // let temList = [];
            // temList = tempActivityList.sort((a, b) => a.order - b.order);
            // this.activityList = _.cloneDeep(temList);
            this.activityList = [];
            this.activityList = _.cloneDeep(tempActivityList);
           //this.manageRfeCaseAction();
            this.mapUserRoles();

            if (callFromEdit) {
              this.editItem = true;
              this.defaultWorkflowConfCompleted = true;
            }
            if (
              this.checkProperty(this.workflowDetailsData, "configCompleted") &&
              this.checkProperty(this.workflowDetailsData, "active") &&
              this.workflowId ==
                this.checkProperty(this.tenantDetails, "defaultWorkflowId")
            ) {
              this.defaultWorkflowConfCompleted = true;
            }

            if(this.isdefaultWorkflowComplted){
                this.defaultWorkflowConfCompleted = true;
            }
          }
        })
        .catch((error) => {
          this.showToster({
            message: error,
            isError: true,
          });
        });
    },
    getTenantDetails() {
      let postData = {
        tenantId: this.getUserData["tenantDetails"]["_id"],
      };
      this.defaultWorkflowConfCompleted = false;
      this.$store
        .dispatch("get_tenant_details", postData)
        .then((response) => {
          this.tenantDetails = response;

          this.edit = true;
          if (_.has(this.tenantDetails, "defaultWorkflowId")) {
            this.workflowId = this.tenantDetails.defaultWorkflowId;

            this.getworkflowDetails();
          }
        })
        .catch((error) => {
          this.showToster({
            message: error,
            isError: true,
          });
        });
    },

    //List Methosd

    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = {
          path: sort_key,
          order: this.sortKeys[sort_key],
        };

        localStorage.setItem("workflow_sort_key", sort_key);
        localStorage.setItem("workflow_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    editMe(item) {
      this.currentStep = 1;

      this.selecteCaseTypes = [];
      Object.assign(this.formerrors, {
        msg: "",
      });

      this.selectedItem = item;
      this.workflowId = this.selectedItem["_id"];
      this.getUserRoles();
      this.getworkflowDetails(true);
      //  this.editItem =true;
    },

    cloneMe(item) {
      this.selectedTenant = null;
      if (
        _.has(item, "tenantDetails") &&
        _.has(item["tenantDetails"], "name") &&
        _.has(item["tenantDetails"], "_id")
      ) {
        this.selectedTenant = item["tenantDetails"];
      }
      Object.assign(this.formerrors, {
        msg: "",
      });
      this.edit = false;
      this.selectedItem = item;
      this.newform = {
        name: this.selectedItem.name,
      };
      this.addPopup = false;
      this.clonePopup = true;
      //alert(this.clonePopup )
    },
    cloneTemplate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let postData = {
            name: this.newform["name"],
            workflowId: this.selectedItem["_id"],
          };
          postData["name"] = postData["name"].trim();

          if (this.selectedTenant && _.has(this.selectedTenant, "_id")) {
            postData = Object.assign(postData, {
              tenantId: this.selectedTenant["_id"],
            });
          }
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/workflow/clone",
            })
            .then((response) => {
              Object.assign(this.formerrors, {
                msg: "",
              });
              this.showToster({
                message: response.message,
                isError: false,
              });
              if (this.selectedTenant && _.has(this.selectedTenant, "_id")) {
                this.searchtxt = "";
                this.filteredTenants = [];
                this.finalFilteredTenants = [];
                this.final_active_statusids = [];
                this.selected_active_statusids = [];
                this.selected_statusids = [];
                this.final_selected_statusids = [];
                this.final_selected_config_completed_statusids = [];
                this.selected_config_completed_statusids = [];

                this.date = "";
                this.date_range = [];
                this.selected_createdDateRange["startDate"] = "";
                this.selected_createdDateRange["endDate"] = "";
                this.filteredTenants.push(this.selectedTenant);
                this.finalFilteredTenants.push(this.selectedTenant["_id"]);
              }
              this.getList();

              this.addPopup = false;
              this.edit = false;
              this.clonePopup = false;
              this.createNew(false);
            })
            .catch((error) => {
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
        }
      });
    },
    createNew(action = true) {
      Object.assign(this.formerrors, {
        msg: "",
      });
      this.selectedTenant = null;
      this.edit = false;
      this.clonePopup = false;
      this.newform = {
        name: "",
        fields: [],
        sections: [],
      };
      this.addPopup = action;
      if (action) {
        this.getActivityList();
      }

      //this.$router.push("/questionnaire-config-add");
    },

    deleteConform(item) {
      this.selectedItem = item;
      this.approveConformpopUp = true;
      this.edit = false;
    },

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      if (this.callFromSerch) {
        this.list = [];
      }

      this.contentLoaded = false;
      this.updateLoading(true);
      let item = {
        filters: {
          title: this.searchtxt.trim(),
          createdDateRange: [],
          //"statusList": this.final_selected_statusids,
          activeList: this.final_selected_statusids, // this.final_active_statusids,
          configList: this.final_selected_config_completed_statusids,
          tenantIds: this.finalFilteredTenants,
        },
        getMasterData: false,
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        //getMasterData:this.getMasterData
      };

      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        item["filters"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }
      // alert(JSON.stringify(item));

      this.$store
        .dispatch("getList", {
          data: item,
          path: "/workflow/list",
        })
        .then((response) => {
          this.updateLoading(false);
          this.list = response.list;
          this.contentLoaded = true;

          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        })
        .catch(() => {
          this.updateLoading(false);
          this.list = [];
          this.contentLoaded = true;
        });
    },

    createConfigTemplate() {
      let self = this;

      this.$validator.validateAll().then((result) => {
        if (result && this.processData(true)) {
          let postData = {
            name: this.newform.name,
            config: this.finalActivity,
          };
          if (
            [1].indexOf(this.getUserRoleId) > -1 &&
            this.selectedTenant &&
            _.has(this.selectedTenant, "_id")
          ) {
            postData = Object.assign(postData, {
              tenantId: this.selectedTenant["_id"],
            });
          }

          postData["name"] = postData["name"].trim();
          postData = Object.assign(postData, {
            active: true,
            configCompleted: true,
          });

          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/workflow/create",
            })
            .then((response) => {
              this.showToster({
                message: response.message,
                isError: false,
              });
              this.getList();
              this.addPopup = false;
              this.createNew(false);
              this.selecteCaseTypes = [];
              setTimeout(() => {
                Object.assign(this.formerrors, {
                  msg: "",
                });
                self.editItem = false;
                self.selectedItem = response;
                self.workflowId = this.selectedItem["_id"];
                self.getworkflowDetails(true);
              });
            })
            .catch((error) => {
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
        }
      });
    },
    set_filter: function () {
      this.$refs["filter_menu"].dropdownVisible = false;
      
      this.final_selected_statusids = [];
      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      this.final_selected_config_completed_statusids = [];
      if (this.selected_config_completed_statusids.length > 0) {
        this.final_selected_config_completed_statusids = [];
        for (
          let ind = 0;
          ind < this.selected_config_completed_statusids.length;
          ind++
        ) {
          let current_index = this.selected_config_completed_statusids[ind];
          this.final_selected_config_completed_statusids.push(
            current_index["id"]
          );
        }
      }

      this.final_active_statusids = [];
      if (this.selected_active_statusids.length > 0) {
        this.final_active_statusids = [];
        for (let ind = 0; ind < this.selected_active_statusids.length; ind++) {
          let current_index = this.selected_active_statusids[ind];
          this.final_active_statusids.push(current_index["id"]);
        }
      }
      this.finalFilteredTenants = [];
      if (this.filteredTenants.length > 0) {
        this.finalFilteredTenants = _.map(this.filteredTenants, "_id");
      }
      // alert(this.final_selected_config_completed_statusids)

      this.getList(true);
    },
    clear_filter: function () {
      this.searchtxt = "";
      this.filteredTenants = [];
      this.finalFilteredTenants = [];
      this.final_active_statusids = [];
      this.selected_active_statusids = [];
      this.$refs["filter_menu"].dropdownVisible = false;
      
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.final_selected_config_completed_statusids = [];
      this.selected_config_completed_statusids = [];

      this.date = "";
      this.date_range = [];
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },

    deleteformandLetter() {
      let post_data = {
        formAndLetterId: this.selectedItem["_id"],
      };
      this.$store
        .dispatch("deleteformandLetter", post_data)
        .then((response) => {
          
          this.approveConformpopUp = false;
          this.showToster({
            message: response.message,
            isError: false,
          });
          this.getList();
          this.edit = false;
        })
        .catch((er) => {
          this.showToster({
            message: er,
            isError: true,
          });
        });
    },

    openPetitionConfiguration(item) {
      this.formerrors.msg = "";
      this.selectedItem = item;
      this.tempPetitionTypeList = this.petitionTypeList;
      this.selectedPetition = null;
      this.workFlowConfigDetails = null;
      this.configPopup = true;
    },

    workFlowconfigAction() {
      this.formerrors.msg = "";
      if (this.selectedPetition != null) {
        let postData = {
          workflowId: this.selectedItem["_id"],
          petitionTypeId: this.selectedPetition["id"],
        };
        this.$store
          .dispatch("commonAction", {
            data: postData,
            path: "/workflow/config-save",
          })
          .then((res) => {
            this.showToster({
              message: res.message,
              isError: false,
            });
            this.selectedPetition = null;
            this.workFlowConfigDetails = null;
            this.configPopup = false;
          })
          .catch((err) => {
            this.formerrors.msg = err;
            this.showToster({
              message: err,
              isError: true,
            });
          });
      }
    },
    getPetitionTypeList() {
      let item = {
        matcher: {
          searchString: "",
          // "petitionType":
        },
        page: 1,
        perpage: 100000000,
        category: "petition_types",
        getMasterData: true,
      };

      this.$store.dispatch("getMasterData", item).then((response) => {
        let tempList = [];
        let lst = response.list;
        _.forEach(lst, (item) => {
          item = Object.assign(item, {
            showMe: true,
          });
          tempList.push(item);
        });
        this.petitionTypeList = tempList;
      });
    },
    openactivepopup(item) {
      this.selectedItem = item;
      this.activateItem = true;
      this.edit = false;
    },
    activateTemplate() {
      let action = true;
      //alert(JSON.stringify(this.selectedItem));
      if (this.selectedItem["active"]) {
        action = false;
      } else {
        action = true;
      }
      let postData = {
        workflowId: this.selectedItem["_id"],
        active: action,
      };
      this.$store
        .dispatch("commonAction", {
          data: postData,
          path: "/workflow/manage-active-status",
        })
        .then((res) => {
          this.activateItem = false;
          this.showToster({
            message: res.message,
            isError: false,
          });
          this.getList();
        })
        .catch((err) => {
          this.showToster({
            message: err,
            isError: true,
          });
        });
    },
    mapUserRoles(){
     
      //this.activityList
      let _self = this;
      let tempActivityList =[];
      if( this.userRolesList.length>0 && this.activityList.length>0 ){
        _.forEach(this.activityList ,(activity)=>{

          if(_.has(activity ,'editors') &&  activity['editors'].length>0){
            let activityEditors =[]
            _.forEach(activity['editors'] ,(editor)=>{
              

              if(_.has(editor ,'roleId')){ 
              let roleMasterData = _.find(_self.masterRoleList ,(item)=> {
                
                return item['id'] == parseInt(editor['roleId']) || item['id'] == editor['roleId'];
              
              });
              // console.log(JSON.stringify(roleMasterData) +"---"+editor['roleId']);
              
              if(roleMasterData && _.has(roleMasterData ,'name') && roleMasterData['name']){
                if(editor.roleId==51&&this.checkProperty(editor,'roleName')=='Sponsor'){
                  editor['roleName'] ='Sponsor'
                  editor=Object.assign(editor,{'uniqueId':5151 });
                  
                 // editor['uniqueId'] =5151
                }else{
                  editor['roleName'] = roleMasterData['name'];
                  if(editor.roleId){
                    editor=Object.assign(editor,{'uniqueId':editor.roleId+editor.roleId });
                  }
                  
                } 
              }
            }
            activityEditors.push(editor)
            })
            if(activityEditors.length>0){
              activity['editors'] = activityEditors;
              
            }


          }
          
          if(_.has(activity ,'watchers') &&  activity['watchers'].length>0){
            let activityWatchers =[]
            _.forEach(activity['watchers'] ,(watcher)=>{
              

              if(_.has(watcher ,'roleId')){ 
              let roleMasterData = _.find(_self.masterRoleList ,(item)=> {
                
                return item['id'] == parseInt(watcher['roleId']) || item['id'] == watcher['roleId'];
              
              });
              //alert(JSON.stringify(roleMasterData) +"---"+watcher['roleId']);
              
              if(roleMasterData && _.has(roleMasterData ,'name') && roleMasterData['name']){
                if(watcher.roleId==51&&this.checkProperty(watcher,'roleName')=='Sponsor'){
                  watcher['roleName'] ='Sponsor'
                  watcher['uniqueId'] =5151
                  
                }else{
                  watcher['roleName'] = roleMasterData['name'];
                  if(watcher.roleId){
                    watcher = Object.assign(watcher,{'uniqueId':watcher.roleId+watcher.roleId });
                  }
                }
                
              }
            }

            activityWatchers.push(watcher)

            })
            if(activityWatchers.length>0){
              activity['watchers'] = activityWatchers;
            }


          }
          
          
          tempActivityList.push(activity);

        })

      }
      if(tempActivityList.length>0){
        // let temList = [];
        // temList = tempActivityList.sort((a, b) => a.order - b.order);
        // this.activityList = _.cloneDeep(temList);
        this.activityList =[];
        this.activityList = tempActivityList;
       
      }
     

    }
  },
  mounted() {
    this.getActivityList();
    this.usersList = [
      "SUPERVISOR_LIST",
      "PARALEGAL_LIST",
      "DOCUMENTATION_MANAGER_LIST",
      "DOCUMENTATION_EXECUTIVE_LIST",
      "ATTORNEY_LIST",
    ];
    this.assignMentUsersList = {
      ASSIGN_SUPERVISOR: "SUPERVISOR_LIST",
      ASSIGN_PARALEGAL: "PARALEGAL_LIST",
      ASSIGN_DOCUMENTATION_MANAGER: "DOCUMENTATION_MANAGER_LIST",
      ASSIGN_DOCUMENTATION_EXECUTIVE: "DOCUMENTATION_EXECUTIVE_LIST",
      ASSIGN_ATTORNEY: "ATTORNEY_LIST",
    };

    // if (_.has(this.$route.params, "id")) {
    //   this.workflowId = this.$route.params.id;
    //   this.edit = true;

    //   this.getworkflowDetails();
    // }
    if ([3, 4].indexOf(this.getUserRoleId) > -1) {
      this.getTenantDetails();
    } else {
      this.getenants();
      this.defaultWorkflowConfCompleted = true;
      this.editItem = false;
    }

    this.getUserRoles();
    this.getList();
    this.getPetitionTypeList();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.limitItems = 1;
    if (this.$route.name == "basic-configuration") {
      this.limitItems = 2;
    }
  },
  directives: {},
  components: {
    workflowList,
    VuePhoneNumberInput,
    FileUpload,
    moment,
    Datepicker,
    InfoIcon,
    XIcon,
    CheckIcon,
    ChevronLeftIcon,
    NoDataFound,
    Paginate,

    DateRangePicker,

    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    workflowActivityOption,
    workflowActivityView,
  },
  watch: {
    '$store.state.manageRfeCase':function(val){
      this.manageRfeCaseAction()

    },
    searchtxt: function (value) {
      this.getList(true);
    },
  },
};
</script>
